import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Logo from "../../assets/images/header/SIA Logo.png";
import Image from "next/image";
import arRow from "../../assets/images/arrow.svg";
import NewiconA from "../../assets/images/contact/redrightarrow.png";
import Link from "next/link";
import { hallticketApiservice } from "../../components/Service/hallticketdownload"; 
import { useState, useRef } from 'react';

import Head from "next/head";

export default function HallTicketPage() {
  const [RegMobile, setRegMobile] = useState('');
  const [submittedData, setSubmittedData] = useState(null);
  const pdfRef = useRef();
  // Example submit handler with enhanced debugging & error handling
  async function downloapdfsubmit(e)
  {
    e.preventDefault();
    const mobile={RegMobile}; 
    console.log(mobile);   
  
    hallticketApiservice(mobile)
   .then((response) => {
    console.log("API Response:", response);
    console.log("API Response:", response.value);
    if(response.success===false)
    {
      alert(response.message);
      //document.getElementById("mobileNumber").reset();
    }
    else{
      setSubmittedData(response.value)
    }
   
  });
    console.log(mobile); 
  }

  const generatePDF = async () => {
  if (typeof window === "undefined") return; // ensures we're in the browser
  const html2pdf = (await import("html2pdf.js")).default;
  const input = pdfRef.current;
  const opt = {
    margin: 10,
    filename: "siahallticket.pdf",
    image: { type: "jpeg", quality: 0.50 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
  };
  
    html2pdf().set(opt).from(input).save().catch((error) => {
      console.error("Error generating PDF:", error);
    });
  };
  

  return (
    <>
    <Head>
        <meta name="robots" content="noindex,nofollow" />
        <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
        <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
        <title>TNPSC Group II & IIA Prelims State Level Mock Test 2026</title>
    </Head>

    <Navbar title="home" />
      
    <h4 className="pt-5 pb-2 text-center" style={{ fontFamily: "Switzer-Bold" ,fontsqize:"20px"}}>
      TNPSC Group II & IIA Prelims State Level Mock Test 2026 - <span style={{ color: "#db1913ff"}}> Download Hall Ticket  </span>
    </h4>

    {/* <div className="col-12 text-center  pb-2 pt-2">
            <span className="d-block ">  <a  className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/mock/UPSC-OFFLINE-INSTRUCTIONS-2026-TEST2.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  />UPSC - ALL INDIA MOCK TEST 2 - OFFLINE INSTRUCTIONS</a></span>
            <span className="d-block"><a className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/mock/UPSC-MOCK-ONLINE-INSTRUCTIONS-2026-TEST2.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  />UPSC - ALL INDIA MOCK TEST 2 - ONLINE INSTRUCTIONS<span></span>  </a> <br /></span>    
            <span className="d-block"><a className='text-danger ' target='_blank' href="https://allindiaupscprelimsmocktest.shankariasacademy.com"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  /><span>UPSC - ALL INDIA MOCK TEST 2 - ONLINE Test - Click Here</span>  </a> <br /></span>    
    </div>  */}

    <div className="container p-4" style={{ background: "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgba(182, 238, 255, 0.29))" }}>   
      <form onSubmit={downloapdfsubmit} className="mobile-label mb-4 col-md-6 mx-auto">
          <label htmlFor="mobileNumber" style={{ fontSize: "15px", textAlign: "justify" }}>Enter your Reg Mobile No :</label>
          <input
            type="tel"
            name="mobileNumber"
            id="mobileNumber"
            required
            value={RegMobile}
            onChange={(e) => setRegMobile(e.target.value)}
            className="form-control mobile-input"
          />
          <button type="submit" className="btn btn-primary mt-3">
            Submit
          </button>
      </form>

      <div className="col-md-6 mx-auto">
          {/* <Link  href="/tnpsc-group-II-IIA-mains-mock-test" target="_blank" rel="noopener noreferrer">
              <span className="mobile-label mb-4 col-md-6 mx-auto" style={{ color: "#db1913ff", fontSize: "19px",  }}> Instructions <Image src={NewiconA} alt="download icon"/></span>
          </Link> */}
      </div>

      <div className="row pt-2">
        <div className="mb-4 col-md-6 mx-auto" style={{ fontSize: "14px", textAlign: "justify" }}>
            <p className=" mb-4 col-md-6"> <b>Enquiry : +91 9360816977</b></p>
        </div>
      </div>


      {/* <div className="row pt-2">
        <div className="mb-4 col-md-6 mx-auto" style={{ fontSize: "14px", textAlign: "justify" }}>
          <p><span className=" mb-4 col-md-6" style={{ color: "#db1913ff", fontSize: "18px",  }}>Instructions to Offline students :</span> </p>
          <p>Dear Offline Students, Kindly bring the Hard copy of <br/>All India UPSC Prelims Mock Test Hall Ticket without Fail</p>
        <p className=" mb-4 col-md-6"> <b>Enquiry : +91 9360816977</b></p>
        </div>

        <div className="mb-4 col-md-6 mx-auto" style={{ fontSize: "14px", textAlign: "justify" }}>
         <p><span className=" mb-4 col-md-6" style={{ color: "#db1913ff", fontSize: "18px",  }}>Instructions to online students only :</span> </p>
         {/* <p>We have arranged a Demo Test (For Trial which consists of 25 Qns) for Online Mode Registration of GR IIA MAINS STATE LEVEL MOCK TEST in the Shankar IAS Academy’s Test Press Portal:</p>
         <p><span className=" mb-4 col-md-6" style={{ color: "#db1913ff", fontSize: "14px",  }}> NON SHANKAR STUDENTS : </span> can access the demo test</p>
       
         <p><b>Test Press Portal : </b><a href="https://shankariastnpsctestbatch.testpress.in/" target="_blank" rel="noopener noreferrer" >https://shankariastnpsctestbatch.testpress.in/</a></p> 
         <p><b>Username : </b>Your Mobile No</p>
         <p><b>Password : </b>Your Mobile No</p>
         <p><span className=" mb-4 col-md-6" style={{ color: "#db1913ff", fontSize: "14px",  }}> SHANKAR STUDENTS : </span> Use your SIAAN ID Provided in the Institute.</p>
        </div>
      </div> */}
    </div>

    { submittedData && (
    <div className="container mt-2 ">
      <button type="button" onClick={generatePDF} className="download-button">
        Download Hall Ticket
      </button>
      <div className="col-12">
        <div ref={pdfRef} className="mt-2 p-2 border rounded-lg bg-gray-600">
          <div className="row">             
            <div className="col-4 ">
              <table className="table">
              </table>
            </div>
            <div className=" d-flex justify-content-center align-items-center ">
              <Image
                src={Logo}
                alt="shankar ias logo"
                title="Shankar IAS Academy"
                className="img-fluid"
                style={{ width: '220px', height: 'auto' }}
              />
            </div>
          </div>
        
          <div className="row">
            <div className="col-12 align-items-center ">
              <div>
                <h5 className="text-center pt-3" style={{ fontFamily: "Switzer-Bold" ,fontSize:"15px" }}>
                  I'M TOP TNPSC GROUP - II & IIA PRELIMS STATE LEVEL MOCK TEST 2026 <br/> MEMORANDUM OF ADMISSION (HALL TICKET)
                </h5>
              </div>
            </div>
          </div>
    
          <div className="formsection">
            <div className="fields">
              <table className="table">
                <thead>
                  <tr>
                    <th>Required Field</th>
                    <th>Candidate Details</th>
                    <th>Candidate’s Photo</th>
                  </tr>
                </thead>

                <tbody>

                  <tr>
                    <td style={{ fontFamily: "Switzer-Bold"}}>Name of the Candidate:</td>
                    <td>
                      <span className="input-field">{submittedData.name}</span>
                    </td>

                    <td rowSpan="8" className="photo">
                      <img src={submittedData.candidatePhoto ? submittedData.candidatePhoto : "/no-image.png"}
                        alt="Uploaded"
                        className="mt-2 object-cover border rounded"
                        style={{ width: "150px", height: "150px" }}
                      />
                    </td>
                  </tr>

                    {/* <tr>
                      <td style={{ fontFamily: "Switzer-Bold"}}>SIA Roll No:</td>
                      <td>
                        <span className="input-field">{submittedData.siarollNo}</span>
                      </td>
                    </tr> */}

                  <tr>
                    <td style={{ fontFamily: "Switzer-Bold"}}>Mobile No:</td>
                      <td>
                          <span className="input-field">{submittedData.mobileNo}</span>
                      </td>
                  </tr>

                  <tr>
                    <td style={{ fontFamily: "Switzer-Bold"}}>Date of Birth:</td>
                      <td>
                        <span className="input-field">{submittedData.dateofbirth}</span>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ fontFamily: "Switzer-Bold"}}>Mode of Exam:</td>
                      <td>
                        <span className="input-field">Offline</span>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ fontFamily: "Switzer-Bold"}}>Subject:</td>
                      <td>
                        <span className="input-field">{submittedData.subject}</span>
                     </td>
                  </tr>

                  <tr>
                      <td style={{ fontFamily: "Switzer-Bold"}}>Exam Timing:</td>
                      <td>
                        <span className="input-field">{submittedData.examTiming}</span>
                      </td>
                  </tr>

                  <tr>
                      <td style={{ fontFamily: "Switzer-Bold"}}>Centre Name:</td>
                      <td>
                        <span className="input-field">{submittedData.centerName}</span>
                      </td>
                  </tr>

                    <tr>
                      <td style={{ fontFamily: "Switzer-Bold"}}>Venue:</td>
                      <td>
                        <span className="input-field">{submittedData.venue ? submittedData.venue :"Update Soon" }</span>
                      </td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div>

          <h6 className="pt-2" style={{ fontFamily: "Switzer-Bold" , fontSize:"14px" }}>
            MOCK TEST DATE AND TIME
          </h6>

          <div className="formsection">
            <div className="fields">
                <table className="table table-bordered">
                    <thead>
                      <tr className="text-center">
                        <th>DATE</th>
                        <th>SUBJECT</th>
                        
                        <th>METHOD</th>
                        {/* <th>INVIGILATOR SIGN</th> */}
                      </tr>
                    </thead>

                    <tbody>
                      <tr className="text-center"> 
                        <td>25.10.2026</td>
                        <td>General Studies (Degree Standard, Aptitude and Mental Ability (SSLC Standard),<br/> and Language (General Tamil or General English</td>
                        
                        <td rowSpan={3} className="align-middle text-center">OMR</td>
                        {/* <td rowSpan={3} className="align-middle text-center"></td> */}
                      </tr>
                    </tbody>
                  </table>
            </div>
          </div>

          <h6 className="pt-2" style={{ fontFamily: "Switzer-Bold" , fontSize:"14px" }}>
              INSTRUCTION TO STUDENTS:
          </h6>
        
            <ul className="pt-0">
              <li style={{ fontSize:"14px" , textAlign:"justify" }}>Candidates are requested to report to the examination venue 45 minutes before the State-Level Mock Test.</li>
              <li style={{ fontSize:"14px" , textAlign:"justify" }}>TNPSC GROUP - II & IIA PRELIMS  Hall Ticket and SIA Hall Ticket is Mandatory to enter into the Exam Hall</li>
              <li style={{ fontSize:"14px" , textAlign:"justify" }}>Candidates must ensure that the <b>OMR sheet is filled carefully</b> and all required details are entered correctly. </li>
              <li style={{ fontSize:"14px" , textAlign:"justify" }}>The candidate should use only<b> BLACK INK </b>Ball Point Pen</li>
              <li style={{ fontSize:"14px" , textAlign:"justify" }}>The Candidate will not be allowed to leave the examination hall before the closure of Exam Time.</li>
              <li style={{ fontSize:"14px" , textAlign:"justify" }}><b>Note:</b> Results will be published in SHANKAR IAS ACADEMY Website and Zero Current Events Telegram Channel</li>
            </ul>
            <p className="pt-2" style={{ fontSize:"14px" , textAlign:"justify" }}><b>GRIEVANCE REDRESSAL & SUPPORT : </b>zerofeedback@shankariasacad.in</p>
            <p className="text-end pt-2" >Student Signature</p>
        </div>
      </div>
    </div>        
    )}

    <style jsx>{`
        .container {
          width: 100%;
          max-width: 900px;
          margin: 0 auto;
          background-color: white;
          padding: 20px;
          border-radius: 10px;
          box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
        }
        .formsection {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 1rem;
        }
        .fields {
          width: 100%;
        }
        .table {
          width: 100%;
          border-collapse: collapse;
        }
        .table td {
          border: 1px solid #00000069;
          padding: 0.5rem;
          background-color: #ffffff;
          color: #161414;
          font-size: 12px;
        }
        th {
          font-family: "Switzer-Bold";
          border: 1px solid #00000069;
          padding: 0.5rem;
          background-color: #f2f2f2;
          font-size: 12px;
        }
        .input-field {
          font-family: Switzer-Medium;
        }
        .photo {
          text-align: center;
        }
        .download-button {
          background-color: red;
          color: white;
          padding: 0.5rem 1rem;
          border: none;
          border-radius: 0.25rem;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }
        .download-button:hover {
          background-color: darkred;
        }

         .mobile-label {
          display: block;
          font-size: 14px;
           margin:10px;
       }
        .mobile-input {
        
          font-size: 14px;
          border: 1px solid #ccc;
          border-radius: 4px;
          width: 100%;
          box-sizing: border-box;
              margin: 10px 0px;
        }

          /* Mobile-specific styles */

        @media (max-width: 600px) {
          .container {
            padding: 10px;
            margin: 0 10px;
          }
          .formsection {
            flex-direction: column;
          }
          .table td,
          th {
            font-size: 14px;
            padding: 0.3rem;
          }
          .download-button {
            padding: 0.4rem 0.8rem;
            font-size: 14px;
          }
        }
    `}</style>

    <Footer />
    </>
  );
}
